const tableTitleTableMaintenances = {
  title: 'Generated Maintenances',
  placeholder: 'Search',
  rowsPerPage: 'Rows Per Page'
};

export default tableTitleTableMaintenances;
